import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import PlaceResult = google.maps.places.PlaceResult;


/**
 * Photo width in pixels
 */
const PHOTO_WIDTH = 100;
/**
 * Photo height in pixels
 */
const PHOTO_HEIGHT = 100;

@Component({
  selector: 'app-activity-summary-card',
  templateUrl: './activity-summary-card.component.html',
  styleUrls: ['./activity-summary-card.component.scss']
})
export class ActivitySummaryCardComponent implements OnInit {
  @Input() activity: PlaceResult;
  @Input() active: boolean;
  @Output() activityMouseEnter = new EventEmitter<PlaceResult>();
  @Output() activityMouseLeave = new EventEmitter<PlaceResult>();

  photoUrl: string = null;
  hoverTimer: any;

  ngOnInit() {
    if (this.activity.photos && this.activity.photos.length) {
      const photo = this.activity.photos[0];
      this.photoUrl = photo.getUrl({ maxWidth: PHOTO_WIDTH, maxHeight: PHOTO_HEIGHT });
    }
  }

  onHover(hover: boolean) {
    clearTimeout(this.hoverTimer);
    this.hoverTimer = setTimeout(() => {
      if (hover) {
        this.activityMouseEnter.emit(this.activity);
      } else {
        this.activityMouseLeave.emit(this.activity);
      }
    }, 400);
  }
}
